<div class="calculator-wrapper">
  <img alt="close button" class="close-button" src="./assets/images/close.png" (click)="dialogRef.close()" />
  <p
    class="calculator-title"
    appConfigSettingsParagraph
  >
    {{ "Calculator.Title" | translate }}
  </p>
  <span
    appConfigSettingsParagraph
  >
    {{ "Calculator.Description" | translate }}
  </span>
  <p
    class="calculator-title"
    appConfigSettingsParagraph
  >
    {{ "Calculator.PrivatCharges" | translate }}
  </p>
  <form [formGroup]="form">
    <div *ngFor="let field of ownFields">
      <div class="calculator-input-container">
        <label
          appConfigSettingsParagraph
        >
          {{ field.title | translate }}
        </label>
        <input
          type="text"
          [formControlName]="field.name"
          mask="0*"
          prefix="€ "
          appConfigSettingsBorder
          appConfigSettingsInput
        />
      </div>
    </div>
    <label class="business-expenses-wrapper">
      <mat-checkbox
        class="checkBox"
        matCheckbox
        type="checkbox"
        color="primary"
        [formControlName]="'businessExpenses'"
      >
      </mat-checkbox>
      <p
        class="calculator-title"
        appConfigSettingsParagraph
      >
        {{ 'Calculator.BusinessExpenses' | translate }}
      </p>
    </label>
    <div *ngIf="showBusinessExpenses">
      <div
        *ngFor="let field of businessFields"
      >
        <div class="calculator-input-container">
          <label
            appConfigSettingsParagraph
          >
            {{ field.title | translate }}
          </label>
          <input
            type="text"
            [formControlName]="field.name"
            mask="0*"
            prefix="€ "
            appConfigSettingsBorder
            appConfigSettingsInput
          />
        </div>
      </div>
    </div>
    <p
      class="calculator-title"
      appConfigSettingsParagraph
    >
      {{ 'Calculator.OtherLivingExpenses' | translate }}
    </p>
    <div class="calculator-input-container">
      <label
        appConfigSettingsParagraph
      >
        {{ 'Calculator.AdditionalAmount' | translate }}
      </label>
      <input
        type="text"
        [formControlName]="'additionalAmount'"
        mask="0*"
        prefix="€ "
        appConfigSettingsBorder
        appConfigSettingsInput
        (change)="additionalAmountChanged()"
      />
    </div>
  </form>
  <div class="calculator-total-wrapper">
    <p
      class="calculator-title"
      appConfigSettingsParagraph
    >
      {{ 'Calculator.MaximumInsuredAmount' | translate }}
    </p>
    <p
      class="calculator-title"
      appConfigSettingsParagraph
    >
      {{calculatorData.amount | currency:'EUR':'symbol':'1.0-0':'nl'}}
    </p>
  </div>
  <div
    class="calculator-controls"
    mat-dialog-actions
  >
    <button
      mat-button
      appConfigSettingsPrimaryButton
      (click)="closeDialog()"
    >
      {{'Calculator.SelectAmount' | translate}}
    </button>
  </div>

</div>
